function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import LeanGallery from './leanGallery/leanGallery';
import ProGallery from './proGallery/proGallery';
import isEligibleForLeanGallery from './leanGallery/isEligible';
import CollageGallery from './presets/collageGallery';
import MasonryGallery from './presets/masonryGallery';
import GridGallery from './presets/gridGallery';
import ThumbnailGallery from './presets/thumbnailGallery';
import SliderGallery from './presets/sliderGallery';
import SlideshowGallery from './presets/slideshowGallery';
import PanoramaGallery from './presets/panoramaGallery';
import ColumnGallery from './presets/columnGallery';
import MagicGallery from './presets/magicGallery';
import FullsizeGallery from './presets/fullsizeGallery';
import BricksGallery from './presets/bricksGallery';
import MixGallery from './presets/mixGallery';
import AlternateGallery from './presets/alternateGallery';
import LAYOUTS from '../../common/constants/layout';
import defaultStyles from '../../common/defaultStyles';
export default (function (props) {
  var styles = props.styles,
      options = props.options,
      styleParams = props.styleParams,
      otherProps = _objectWithoutPropertiesLoose(props, ["styles", "options", "styleParams"]);

  var _styles = _objectSpread({}, defaultStyles, {}, options, {}, styles, {}, styleParams);

  var galleryProps = _objectSpread({}, otherProps, {
    styles: _styles
  });

  var GalleryComponent = ProGallery;

  if (isEligibleForLeanGallery(galleryProps)) {
    GalleryComponent = LeanGallery;
  } else {
    var galleryLayout = _styles.galleryLayout;

    switch (galleryLayout) {
      case LAYOUTS.COLLAGE:
        GalleryComponent = CollageGallery;
        break;

      case LAYOUTS.MASONRY:
        GalleryComponent = MasonryGallery;
        break;

      case LAYOUTS.GRID:
        GalleryComponent = GridGallery;
        break;

      case LAYOUTS.THUMBNAIL:
        GalleryComponent = ThumbnailGallery;
        break;

      case LAYOUTS.SLIDER:
        GalleryComponent = SliderGallery;
        break;

      case LAYOUTS.SLIDESHOW:
        GalleryComponent = SlideshowGallery;
        break;

      case LAYOUTS.PANORAMA:
        GalleryComponent = PanoramaGallery;
        break;

      case LAYOUTS.COLUMN:
        GalleryComponent = ColumnGallery;
        break;

      case LAYOUTS.MAGIC:
        GalleryComponent = MagicGallery;
        break;

      case LAYOUTS.FULLSIZE:
        GalleryComponent = FullsizeGallery;
        break;

      case LAYOUTS.BRICKS:
        GalleryComponent = BricksGallery;
        break;

      case LAYOUTS.MIX:
        GalleryComponent = MixGallery;
        break;

      case LAYOUTS.ALTERNATE:
        GalleryComponent = AlternateGallery;
        break;
    }
  }

  return React.createElement(GalleryComponent, galleryProps);
});